import React from "react"

class DefaultDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>{typeof this.props.data !== 'undefined' ? this.props.data : <span className="none">{I18n.t('none')}</span>}</div>
    );
  }

};

export default DefaultDataType